import { useEffect, useRef, useState } from 'react'
import './LoadingScreenNew.css'

function LoadingScreenNew({ onFinished }) {
  const [fade, setFade] = useState(false)
  const videoRef = useRef(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    // Tắt PiP hoàn toàn qua JS API (loại bỏ badge "1.0x" / speed indicator)
    if (typeof video.disablePictureInPicture !== 'undefined') {
      video.disablePictureInPicture = true
    }
    if (document.pictureInPictureEnabled) {
      video.addEventListener('enterpictureinpicture', (e) => e.target.exitPictureInPicture?.())
    }

    const handleEnded = () => {
      setFade(true)
      const timer = setTimeout(() => {
        if (onFinished) onFinished()
      }, 900)
      return () => clearTimeout(timer)
    }

    video.addEventListener('ended', handleEnded)
    return () => {
      video.removeEventListener('ended', handleEnded)
    }
  }, [onFinished])

  return (
    <div className={`loading-screen-new${fade ? ' loading-screen-new--fade-out' : ''}`}>
      <video
        ref={videoRef}
        className="loading-screen-new__video"
        src="/video/loading.webm"
        preload="auto"
        autoPlay
        muted
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        x-webkit-airplay="deny"
        controlsList="noplaybackrate nofullscreen nodownload noremoteplayback"
      />
    </div>
  )
}

export default LoadingScreenNew
